export default __webpack_public_path__ + "static/media/banknotes.1298b63b.svg";